import {
    IconSexMale,
    IconSexFemale,
    IconSexOther,
    IconSexTransgender,
    IconSexUnknown,
    IconEwiCheck,
    IconEwiInfo,
    IconEwiErrorRound,
    IconEwiQuestion,
    IconEwiWarningRound,
    IconCamera,
    IconVideoFile,
    IconVideo,
    IconImage,
    IconUser,
    IconShare,
    IconFolder,
    IconTag,
    IconDownload,
    IconEdit,
    IconDelete,
    IconFavoriteOutlined,
    IconFavoriteFilled,
    IconSearch,
} from 'components/Zui/Icon'

import movetofolder from 'images/movetofolder.svg'
import downloadIcnDark from 'images/downloadIcnDark.svg'
import movetofolderDark from 'images/movetofolderDark.svg'
import tagIcnDark from 'images/tagIcnDark.svg'

export const genderIcons = {
    male: IconSexMale,
    female: IconSexFemale,
    other: IconSexOther,
    trans: IconSexTransgender,
    unknown: IconSexUnknown,
}

export const ewiIcons = {
    check: <IconEwiCheck slot="icon" />,
    info: <IconEwiInfo slot="icon" />,
    error: <IconEwiErrorRound slot="icon" />,
    question: <IconEwiQuestion slot="icon" />,
    warning: <IconEwiWarningRound slot="icon" />,
}

export const icons = {
    camera: IconCamera,
    image: IconImage,
    video: IconVideoFile,
    user: IconUser,
    folder: IconFolder,
    share: IconShare,
    delete: IconDelete,
    edit: IconEdit,
    favorite: IconFavoriteOutlined,
    favoriteFilled: IconFavoriteFilled,
    tag: IconTag,
    search: IconSearch,
    download: IconDownload,
    moveFolder: props => <img src={movetofolder} alt="" {...props} />,
    downloadIcnDark: props => <img src={downloadIcnDark} alt="" {...props} />,
    movetofolderDark: props => <img src={movetofolderDark} alt="" {...props} />,
    tagIcnDark: props => <img src={tagIcnDark} alt="" {...props} />,
    videoCam: IconVideo,
}

export const dateFormats = {
    dob: 'dd. MMM. yyyy',
}

export const salutation = [
    { code: 'm', name: 'Mr' },
    { code: 'f', name: 'Mrs' },
    { code: 'na', name: 'Unknown' },
]

export const PATIENT_FILE_FILTERS = [
    { label: 'All', value: 'all' },
    { label: 'Images', value: 'image' },
    { label: 'Videos', value: 'video' },
]

export const PATIENT_DATE_FILTER_OPTIONS = [
    { label: 'All', value: 'all' },
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Last 7 days', value: 'last7' },
    { label: 'Last 30 days', value: 'last30' },
    { label: 'Custom (date range)', value: 'custom' },
]
